/** Lettura, validazione e importazione dei compose. */
export const compose = {
  // Validatore
  "compose.immagineMancante": (p: { servizio: string }) =>
    `il servizio "${p.servizio}" non dichiara un'immagine. ` +
    "Portman avvia stack a partire da immagini già presenti in un registry.",
  "compose.tagMancante": (p: { immagine: string; servizio: string }) =>
    `l'immagine "${p.immagine}" del servizio "${p.servizio}" non indica un tag. ` +
    "Il tag è obbligatorio: senza, non è possibile sapere quale versione è in esecuzione " +
    "né tornare a quella precedente.",
  "compose.tagMobile": (p: { servizio: string; tag: string }) =>
    `il servizio "${p.servizio}" usa il tag mobile "${p.tag}": il suo contenuto può ` +
    "cambiare senza preavviso, rendendo i deploy non riproducibili.",
  "compose.portaDuplicata": (p: { porta: string; protocollo: string; primo: string; secondo: string }) =>
    `la porta host ${p.porta}/${p.protocollo} è richiesta sia da "${p.primo}" ` +
    `sia da "${p.secondo}": due servizi non possono ascoltare sulla stessa porta.`,
  "compose.portaNonGestita": (p: { servizio: string; porta: number }) =>
    `il servizio "${p.servizio}" espone la porta ${p.porta} senza indicare quella host: ` +
    "sarà Docker a sceglierne una a caso a ogni avvio. Usa una variabile per lasciarla gestire a Portman.",
  "compose.variabileObbligatoria": (p: { variabile: string }) =>
    `la variabile "${p.variabile}" è obbligatoria nel compose ma non ha un valore. ` +
    "Impostala nell'environment dello stack.",
  "compose.variabileVuota": (p: { variabile: string }) =>
    `la variabile "${p.variabile}" non ha un valore: il compose la userà vuota.`,
  "compose.variabileInutile": (p: { variabile: string; file: string }) =>
    `la variabile "${p.variabile}" è definita nell'environment ma non è usata dal compose. ` +
    `Se serve all'applicazione, dichiarala nel servizio — "environment: - ${p.variabile}" ` +
    `per la singola variabile, "env_file: ${p.file}" per l'intero environment.`,

  // Parser
  "compose.vuoto": "il file compose è vuoto",
  "compose.yamlNonValido": (p: { dettaglio: string }) => `YAML non valido: ${p.dettaglio}`,
  "compose.portaNonValida": (p: { voce: string; valore: string }) => `porta non valida in "${p.voce}": ${p.valore}`,
  "compose.portaSenzaTarget": (p: { voce: string }) => `porta in sintassi estesa senza "target": ${p.voce}`,
  "compose.portsNonElenco": (p: { servizio: string }) => `"ports" del servizio ${p.servizio} deve essere un elenco`,
  "compose.portaNonRiconosciuta": (p: { servizio: string; voce: string }) =>
    `voce di "ports" non riconosciuta nel servizio ${p.servizio}: ${p.voce}`,
  "compose.exposeNonElenco": (p: { servizio: string }) => `"expose" del servizio ${p.servizio} deve essere un elenco`,
  "compose.portmanNonMappa": (p: { servizio: string }) =>
    `"x-portman" del servizio ${p.servizio} deve essere una mappa di proprietà`,
  "compose.portmanChiave": (p: { chiave: string; servizio: string }) =>
    `chiave sconosciuta "${p.chiave}" sotto x-portman del servizio ${p.servizio}`,
  "compose.fissoNonBooleano": (p: { servizio: string }) =>
    `"x-portman.fisso" del servizio ${p.servizio} deve essere un booleano`,
  "compose.reteNonRiconosciuta": (p: { servizio: string }) =>
    `"networks" del servizio ${p.servizio} non è riconosciuto`,
  "compose.servizioNonMappa": (p: { servizio: string }) => `il servizio ${p.servizio} deve essere una mappa di proprietà`,
  "compose.radiceNonMappa": "il file compose deve contenere una mappa di sezioni",
  "compose.senzaServizi": 'il file compose deve dichiarare almeno un servizio in "services"',

  // Rimozione delle porte host
  "compose.porteHost.ripetute": 'dichiara "ports:" più di una volta',
  "compose.porteHost.inLinea": "dichiara le porte in linea, su una riga sola",
  "compose.porteHost.estesa": "usa la sintassi estesa, su più righe",
  "compose.porteHost.forma": "ha una forma che non so togliere riga per riga",

  // Importazione
  "compose.import.vuoto": "nessun container da importare: il progetto non ha servizi",
  "compose.import.senzaTag": (p: { servizio: string; immagine: string }) =>
    `Il servizio "${p.servizio}" usa l'immagine "${p.immagine}" senza un tag ` +
    "esplicito: aggiungilo prima di avviare, perché senza non è possibile sapere quale " +
    "versione è in esecuzione né tornare a quella precedente.",
  "compose.import.porte":
    "Le porte host sono state riportate come sono, per non cambiare l'indirizzo di un " +
    "servizio già in funzione. Per affidarle a Portman, sostituiscile con una variabile — " +
    'ad esempio "${PORT_WEB}:80" — e verranno assegnate e mantenute stabili nel tempo.',
  "compose.import.dipendenze":
    "Docker non conserva l'ordine di avvio dei servizi: se lo stack aveva delle dipendenze " +
    "dichiarate con depends_on, vanno reinserite a mano.",

  // Porte e password
  "compose.poolEsaurito": (p: { inizio: number; fine: number }) =>
    `nessuna porta libera nell'intervallo ${p.inizio}-${p.fine}. ` +
    "Amplia il pool configurato oppure libera le porte non più in uso.",
  "password.corta": (p: { minimo: number }) => `deve contenere almeno ${p.minimo} caratteri`,
  "password.comune": "è una password troppo comune",
  "password.ripetuta": "non può essere composta da un solo carattere ripetuto",
};
